$(document).on("click", "#no_funds_button", function() {
  return $.ajax({
    url: $(this).data("url"),
    method: "POST",
    success: this.handleSuccess
  });
});
